import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material"
import Button from "@mui/material/Button"
import * as React from "react"

export const ErrorDialog = ({ message, closeDialog }) => {
  return (
    <>
      <DialogTitle id="alert-error-dialog-title">Error</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-error-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={closeDialog}
          color="primary"
          variant="contained"
          autoFocus
        >
          OK
        </Button>
      </DialogActions>
    </>
  )
}
